//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
    return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
    return originalReplace.call(this , location).catch(err=>err)
}

// import reanalysis  from '../view/reanalysis';
// import reanalysisDetial  from '../view/reanalysisDetial';
// import taskList  from '../view/taskList';
import contentManage  from '../view/ContentManage/index';
import ColumnManage  from '../view/ColumnManage/index';
import content  from '../view/Content/content';

//定义routes路由的集合，数组类型
const routes=[
    //单个路由均为对象类型，path代表的是路径，component代表组件
    // {path:'/reanalysis',component:reanalysis,meta:{title:'重解析'}},
    // {path:"/reanalysisDetial",component:reanalysisDetial ,meta:{title:'重解析详情'}},
    // {path:"/taskList",component:taskList,meta:{title:'重解析任务'}},
    // {path:'*',redirect:'/reanalysis',component:reanalysis,meta:{title:'重解析'}},
    {path:'/columnManage',component:ColumnManage, name:'AcolumnManage', meta:{title:'栏目管理'}},
    {path:'/contentManage',component:contentManage,name:'AcontentManage', meta:{title:'内容管理'}},
    {path:'/content',component:content,name:'Acontent', meta:{title:'内容管理',hidden:true}},
    {path:'*',redirect:'/columnManage',component:ColumnManage,meta:{title:'栏目管理',hidden:true}},
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
    routes
});

//抛出这个这个实例对象方便外部读取以及访问
export default router
